import { render } from "./ev3Testing.vue?vue&type=template&id=397b3cbe&scoped=true"
import script from "./ev3Testing.vue?vue&type=script&lang=js"
export * from "./ev3Testing.vue?vue&type=script&lang=js"

import "./ev3Testing.vue?vue&type=style&index=0&id=397b3cbe&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397b3cbe"]])

export default __exports__